import Overview from './overview.vue';
import Full from '@rebuild/materials/shared/announcement/FullIndex.vue';
import MobOverview from '@rebuild/materials/shared/announcement/mobile/MobOverviewIndex.vue';
import MobFull from '@rebuild/materials/shared/announcement/mobile/FullIndex.vue';

import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/announcement/context';
import { ref, computed } from 'vue';
import i18n, { EN, languageTypeMap } from '@/locales';

function useSelfContext() {
	const isENSie = computed(() => i18n.locale == EN);
	const languageType = ref(isENSie.value ? { languageType: 0 } : { languageType: languageTypeMap[i18n.locale] });
	provideCurrentContext({
		languageType
	});
}

export const componentMap = {
	overview: Overview,
	full: withProvider(Full, useSelfContext),
	'mob-overview': withProvider(MobOverview, useSelfContext),
	'mob-full': withProvider(MobFull, useSelfContext)
};
